"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _Paper = _interopRequireDefault(require("material-ui/Paper"));

var _FlatButton = _interopRequireDefault(require("material-ui/FlatButton"));

var _Card = require("material-ui/Card");

var _utils = require("../../../lib/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

require('../../../sass/components/shared/elements/ExpanderAnnouncementReview.css');

var blankImg = require('../../../images/no-photo@2x.png');

var newArrow = require('../../../images/dash/down-chevron@2x.png');

var ExpanderAnnouncementReview = /*#__PURE__*/function (_React$Component) {
  _inherits(ExpanderAnnouncementReview, _React$Component);

  var _super = _createSuper(ExpanderAnnouncementReview);

  function ExpanderAnnouncementReview() {
    _classCallCheck(this, ExpanderAnnouncementReview);

    return _super.apply(this, arguments);
  }

  _createClass(ExpanderAnnouncementReview, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          bodyEmphasis = _this$props.bodyEmphasis,
          expanderSubtitle = _this$props.expanderSubtitle,
          image = _this$props.image,
          editFn = _this$props.editFn,
          viewFn = _this$props.viewFn,
          body = _this$props.body,
          createdByFuneralHome = _this$props.createdByFuneralHome,
          tagFollowedUp = _this$props.tagFollowedUp; // @lines 56 & 57: MUI prop names _probably_ mean to say "closed state icon" and
      // "opened state icon", which is the reason for reversed values

      var viewIcon = /*#__PURE__*/_react.default.createElement("div", {
        className: "view-icon"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "expander-button-text"
      }, "View"), /*#__PURE__*/_react.default.createElement("img", {
        src: newArrow
      }));

      var closeIcon = /*#__PURE__*/_react.default.createElement("div", {
        className: "close-icon",
        onClick: function onClick(e) {
          (0, _utils.googleAnalytics)('announcements-openannouncement', undefined, {
            dimension3: _this.props.memorialId
          })(e);
        }
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "expander-button-text"
      }, "Close"), /*#__PURE__*/_react.default.createElement("img", {
        src: newArrow
      }));

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "expander-review-body"
      }, /*#__PURE__*/_react.default.createElement(_Card.Card, {
        className: "expander-review-card"
      }, /*#__PURE__*/_react.default.createElement(_Card.CardHeader, {
        className: "expander-card-header",
        style: {
          display: 'flex'
        },
        title: /*#__PURE__*/_react.default.createElement("p", {
          className: "expander-emphasis"
        }, bodyEmphasis, tagFollowedUp && /*#__PURE__*/_react.default.createElement("span", {
          className: "announcement-tag tag-followed-up"
        }, "Followed up")),
        subtitle: expanderSubtitle,
        subtitleStyle: {
          whiteSpace: 'nowrap'
        },
        avatar: /*#__PURE__*/_react.default.createElement(_Paper.default, {
          className: "photo-upload-viewer",
          zDepth: 1,
          rounded: false,
          style: {
            backgroundImage: "url(".concat(image, ")")
          }
        }, !image && /*#__PURE__*/_react.default.createElement("img", {
          src: blankImg,
          className: "photo-upload-viewer-blank",
          alt: "No Image Uploaded"
        })),
        actAsExpander: true,
        showExpandableButton: true,
        closeIcon: viewIcon,
        openIcon: closeIcon
      }), editFn && /*#__PURE__*/_react.default.createElement(_Card.CardActions, {
        className: "expander-review-edit"
      }, /*#__PURE__*/_react.default.createElement(_FlatButton.default, {
        className: "card-action-button",
        label: "View",
        labelStyle: {
          color: '#464d5f'
        },
        onClick: viewFn,
        style: {
          marginLeft: 'auto',
          marginTop: '6.7rem'
        }
      }), createdByFuneralHome && /*#__PURE__*/_react.default.createElement(_FlatButton.default, {
        className: "card-action-button",
        label: "Edit",
        labelStyle: {
          color: 'white'
        },
        backgroundColor: '#0072cd',
        onClick: editFn,
        style: {
          marginLeft: 'auto',
          marginTop: '6.7rem'
        }
      })), /*#__PURE__*/_react.default.createElement(_Card.CardText, {
        expandable: true
      }, body)));
    }
  }]);

  return ExpanderAnnouncementReview;
}(_react.default.Component);

exports.default = ExpanderAnnouncementReview;